import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const CompanyTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:companies')}
        thClassName="w-[230px] max-sm:min-w-[170px]"
        sortable
        onSortClick={() => onSort?.('companyName')}
      />
      <TableHead
        text={t('common:branches')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead
        text={t('common:group')}
        thClassName="w-[200px] max-sm:min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('groupName')}
      />
      <TableHead
        text={t('common:usage')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead
        text={t('common:address')}
        thClassName="w-[220px] max-sm:min-w-[170px]"
      />
      <TableHead text={t('common:whiteLabel')} thClassName="min-w-0 w-0" />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
